import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface ConfirmationProps {
  show: boolean
  onClose: () => void
  onAccept: () => void
}

export const Confirmation = ({
  show,
  onClose,
  onAccept,
}: ConfirmationProps) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.type.evaluation.modals.hasResponses',
  })
  return (
    <ConfirmationModal
      show={show}
      title={t('title')}
      text={t('text')}
      acceptButtonText={t('buttons.accept')}
      onAccept={onAccept}
      onClose={onClose}
    />
  )
}
